import * as React from 'react'

import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { ProfileEmployeeLocationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import EmployeeWorkplacesListItem from '../EmployeeWorkplacesListItem'

interface Props {
  employeeId: number
  accessId: number
  employeeLocations: ProfileEmployeeLocationFragment[]
  defaultLocationId: number | null
  canAssignLocations: boolean
  onDefaultLocationUpdated: (id: number) => void
}

const EmployeeWorkplacesList = ({
  employeeId,
  accessId,
  defaultLocationId,
  employeeLocations,
  canAssignLocations,
  onDefaultLocationUpdated,
}: Props) => {
  const defaultLocation =
    defaultLocationId != null
      ? employeeLocations.find((location) => defaultLocationId == location.id)
      : undefined

  return (
    <List>
      {defaultLocation && (
        <EmployeeWorkplacesListItem
          locationName={defaultLocation.name}
          isLocationDefault
          employeeId={employeeId}
          accessId={accessId}
          locationId={defaultLocation.id}
          canAssignLocations={canAssignLocations}
          onDefaultLocationUpdated={onDefaultLocationUpdated}
        />
      )}
      {employeeLocations.map((location) => {
        const isLocationDefault = defaultLocation == location
        if (isLocationDefault) return

        return (
          <EmployeeWorkplacesListItem
            key={location.id}
            locationName={location.name}
            isLocationDefault={isLocationDefault}
            employeeId={employeeId}
            accessId={accessId}
            locationId={location.id}
            canAssignLocations={canAssignLocations}
            onDefaultLocationUpdated={onDefaultLocationUpdated}
          />
        )
      })}

      {employeeLocations.length === 0 && (
        <List.Item>
          <Box
            flexDirection="row"
            alignItems="center"
            width="full"
            justifyContent="spaceBetween"
            gap="s24"
          >
            <Text color="grey800" weight="normal" size="200">
              {i18n.t('employee_form.workplaces.no_workplaces')}
            </Text>
          </Box>
        </List.Item>
      )}
    </List>
  )
}

export default observer(EmployeeWorkplacesList)
